module.exports = __webpack_public_path__ + "static/media/loadingIMG_2.d739f3ba.jpg";